<template>
  <!-- GIS系统-物探点数据 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="道路选择"> 
              <a-select mode="multiple" show-search v-model="query.road" placeholder="请选择道路（可多选）" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="item in roadNameOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="分类编号">
              <a-input v-model="query.classNo" placeholder="请输入分类编号" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入物探点号" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="构筑物">
              <a-select placeholder="请选择构筑物" v-model="query.structure" allow-clear>
                <a-select-option v-for="item in structureOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="材质">
              <a-select mode="multiple" v-model="query.textureMaterial" placeholder="请选择管线材质（可多选）" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="(item, index) in pipeLineMaterialOptions" :key="index" :value="item">{{
                  item
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="口径">
              <a-select mode="multiple" placeholder="请选择口径大小（可多选）" v-model="query.caliber" allow-clear
                :max-tag-count="2">
                <a-select-option v-for="(item, index) in pipeDiameterSizeOptions" :key="index" :value="item">
                  DN{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="特征点">
              <a-select placeholder="请选择特征点" v-model="query.featurePoint" allow-clear>
                <a-select-option v-for="item in featurePointOptions" :key="item" :value="item">{{
                  item
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="附属物">
              <a-select placeholder="请选择附属物" v-model="query.appendage" allow-clear>
                <a-select-option v-for="item in appendageOptions" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="创建时间" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-range-picker v-model="createTimeRange" @change="onDateChange" format="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                style="width: 100%" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="12">
            <a-form-item label="竣工时间" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
              <a-range-picker v-model="completionTimeRange" @change="onCompletionDateChange" format="YYYY-MM-DD HH:mm:ss"
                :show-time="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                style="width: 100%" />
            </a-form-item>
          </a-col> -->
        </a-row>
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()"
                :loading="batchOperationLoading" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ excelForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                v-action:recycle>回收站</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="clear" v-action:clear>一键清空数据</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered :row-selection="{
      selectedRowKeys: this.selectedRows,
      onChange: onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: batchOperationLoading
      })
    }" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading || batchOperationLoading" :pagination="pagination"
      @change="pageChange">
      <a-tag color="blue" slot="status" slot-scope="text">{{ text ? 'yes' : 'NO' }}</a-tag>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandleEdit(record.id, record.class_no)" v-action:edit>编辑</a>
        <a-divider type="vertical" />
        <a @click="viewOnMap(record)" style="color: #1890ff">详情</a>
      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" :maskClosable="false" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-row class="form-row" :gutter="16">
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编号">
              <a-input :disabled="this.isUpdate" placeholder="分类编号" style="width: 100%"
                v-decorator="['class_no', { rules: [{ required: true, message: '请输入分类编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物探点号">
              <a-input placeholder="物探点"
                v-decorator="['geophysicalPointNumber', { rules: [{ required: true, message: '请输入物探点号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="特征点">
              <a-input placeholder="特征点"
                v-decorator="['featurePoint', { rules: [{ required: false, message: '请输入特征点' }] }]" />
              <!--              <a-select-->
              <!--                :getPopupContainer="-->
              <!--                  triggerNode => {-->
              <!--                    return triggerNode.parentNode || document.body;-->
              <!--                  }-->
              <!--                "-->
              <!--                placeholder="请选择特征点"-->
              <!--                v-decorator="['featurePoint', { rules: [{ required: true, message: '请选择特征点' }] }]"-->
              <!--              >-->
              <!--                <a-select-option v-for="(item) in PointList" :key="item.dictValue">{{ item.dictName }}</a-select-option>-->
              <!--              </a-select>-->
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附属物">
              <a-input placeholder="附属物"
                v-decorator="['appendage', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="构筑物">
              <a-input placeholder="构筑物"
                v-decorator="['structure', { rules: [{ required: false, message: '请输入构筑物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点X">
              <a-input placeholder="坐标点X" v-decorator="[
                'point_x',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点X' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="坐标点Y">
              <a-input placeholder="坐标点Y" v-decorator="[
                'point_y',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入坐标点Y' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程">
              <a-input placeholder="地面高程" v-decorator="[
                'elevation',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入地面高程m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="口径">
              <a-input placeholder="口径" v-decorator="['caliber', { rules: [{ required: false, message: '请输入口径' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="材质">
              <a-input placeholder="材质"
                v-decorator="['textureMaterial', { rules: [{ required: false, message: '请输入材质' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="埋深m">
              <a-input placeholder="埋深" v-decorator="[
                'buriedDepth',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入埋深m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="敷设方式">
              <a-input placeholder="敷设方式"
                v-decorator="['layingMode', { rules: [{ required: false, message: '请输入敷设方式' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称">
              <a-input placeholder="片区名称"
                v-decorator="['zoneName', { rules: [{ required: false, message: '请输入片区名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="道路选择">
              <a-input placeholder="所属道路"
                v-decorator="['road', { rules: [{ required: false, message: '请输入所属道路' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原始文件名">
              <a-input placeholder="原始文件名"
                v-decorator="['originalFileName', { rules: [{ required: false, message: '请输入原始文件名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="探测台组编号">
              <a-input placeholder="探测台组编号"
                v-decorator="['probeGroupNo', { rules: [{ required: false, message: '请输入探测台组编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表数量">
              <a-input placeholder="水表数量" v-decorator="[
                'water_count',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入水表数量' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门类型">
              <a-input placeholder="阀门类型"
                v-decorator="['valve_type', { rules: [{ required: false, message: '请输入阀门类型' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
              <a-select placeholder="请选择状态" v-decorator="['status', { initialValue: '良好' }]">
                <a-select-option value="良好">良好</a-select-option>
                <a-select-option value="密封性能差">密封性能差</a-select-option>
                <a-select-option value="损坏">损坏</a-select-option>
                <a-select-option value="联通阀门关闭">联通阀门关闭</a-select-option>
                <a-select-option value="常闭阀门">常闭阀门</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌">
              <a-input placeholder="品牌" v-decorator="['brand', { rules: [{ required: false, message: '请输入品牌' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="出厂编号">
              <a-input placeholder="出厂编号"
                v-decorator="['factoryNumber', { rules: [{ required: false, message: '请输入出厂编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号">
              <a-input placeholder="型号" v-decorator="['model', { rules: [{ required: false, message: '请输入型号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程名称">
              <a-input placeholder="工程名称"
                v-decorator="['projectName', { rules: [{ required: false, message: '请输入工程名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程类别">
              <a-input placeholder="工程类别"
                v-decorator="['projectType', { rules: [{ required: false, message: '工程类别' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程编号">
              <a-input placeholder="工程编号"
                v-decorator="['projectNo', { rules: [{ required: false, message: '工程编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="施工单位">
              <a-input placeholder="施工单位"
                v-decorator="['constructionUnit', { rules: [{ required: false, message: '施工单位' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程管理人">
              <a-input placeholder="工程管理人"
                v-decorator="['projectManager', { rules: [{ required: false, message: '工程管理人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程负责人">
              <a-input placeholder="工程负责人"
                v-decorator="['projectLeader', { rules: [{ required: false, message: '工程负责人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="竣工时间">
              <a-input placeholder="竣工时间"
                v-decorator="['completion_date', { rules: [{ required: false, message: '竣工时间' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '备注' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加压泵类型">
              <a-input placeholder="加压泵类型"
                v-decorator="['forcingPumpStatus', { rules: [{ required: false, message: '请输入加压泵类型' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机组数量">
              <a-input placeholder="机组数量" v-decorator="[
                'unitNum',
                { rules: [{ pattern: /^[0-9]*[1-9][0-9]*$/, required: false, message: '请输入机组数量' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="机组功率">
              <a-input placeholder="机组功率" v-decorator="[
                'unitPower',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入机组功率' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门级别">
              <a-input-number placeholder="阀门级别" :min="1" v-decorator="[
                'valveLevel',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入阀门级别' }] },
              ]" />
            </a-form-item>
          </a-col>

          <a-col v-if="canUploadSiteImages" :lg="24" :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="现场图片">
              <a-upload
                accept="image/*"
                list-type="picture-card"
                :file-list="siteImagesFileList"
                :customRequest="handleSiteImageUpload"
                :beforeUpload="beforeSiteImageUpload"
                @preview="handleSiteImagePreview"
                @change="handleSiteImageChange"
              >
                <div v-if="siteImagesFileList.length < 3">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
              <!-- 作为提交字段：后端需要 JSON 字符串数组格式 -->
              <a-input v-decorator="['siteImages']" style="display: none" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <!-- 图片预览优化版 -->
    <a-modal
      :visible="siteImagePreviewVisible"
      :footer="null"
      :closable="false"
      @cancel="handleSiteImagePreviewCancel"
      width="100%"
      wrapClassName="full-screen-preview-modal"
      :bodyStyle="{ padding: 0, height: '100vh', display: 'flex', flexDirection: 'column', background: 'rgba(0,0,0,0.85)', overflow: 'hidden' }"
    >
      <!-- 顶部状态栏 -->
      <div class="preview-header">
        <div class="preview-count">{{ (siteImagePreviewIndex + 1) }} / {{ siteImagePreviewUrls.length }}</div>
        <div class="preview-close" @click="handleSiteImagePreviewCancel">
          <a-icon type="close" />
        </div>
      </div>

      <!-- 图片主体区域 -->
      <div class="preview-body" @wheel.prevent="handleBodyWheel">
        <!-- 左切换 -->
        <div v-if="siteImagePreviewIndex > 0" class="nav-btn left" @click="previewPrev">
          <a-icon type="left" />
        </div>

        <!-- 图片 -->
        <div class="image-wrapper">
          <img
            alt="预览图片"
            class="preview-image"
            :src="siteImagePreviewUrl"
            :style="{ transform: `scale(${siteImageScale}) rotate(${siteImageRotate}deg)` }"
          />
        </div>

        <!-- 右切换 -->
        <div v-if="siteImagePreviewIndex < siteImagePreviewUrls.length - 1" class="nav-btn right" @click="previewNext">
          <a-icon type="right" />
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="preview-footer">
        <a-tooltip title="放大"><a-icon type="plus-circle" @click="handleImageScale(0.2)" /></a-tooltip>
        <a-tooltip title="缩小"><a-icon type="minus-circle" @click="handleImageScale(-0.2)" /></a-tooltip>
        <a-tooltip title="旋转"><a-icon type="reload" @click="handleImageRotate" /></a-tooltip>
        <a-tooltip title="重置"><a-icon type="sync" @click="handleImageReset" /></a-tooltip>
      </div>
    </a-modal>
    <importModal ref="importModal" :tree-data="road" exportUrl="/pipe-network/gis/pipe-networks/import" @close="close"
      @reLoad="resetList"></importModal>
    <RecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk"></RecycleBinModal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import importModal from './module/ImportModalNotZone.vue'
import RecycleBinModal from './module/NewPipeNetworkRecycleBinModal'
import { listPipeNetworkByGroupProperties } from '@/api/manage'
import moment from 'moment'
import { handleImportBlobResponse } from '@/utils/importUtils'
// import { SelectTypes } from 'ant-design-vue/es/select';
// import { defineComponent, ref } from 'vue';

const STATUS = { 1: '正常', 2: '禁用' }

const columns = [
  {
    title: '分类编号',
    dataIndex: 'class_no',
  },
  {
    title: '物探点',
    dataIndex: 'geophysicalPointNumber',
  },
  {
    title: '特征点',
    dataIndex: 'featurePoint',
  },
  {
    title: '附属物',
    dataIndex: 'appendage',
  },
  {
    title: '构筑物',
    dataIndex: 'structure',
  },
  {
    title: '坐标X',
    dataIndex: 'point_x',
  },
  {
    title: '坐标Y',
    dataIndex: 'point_y',
  },
  {
    title: '材质',
    dataIndex: 'textureMaterial',
  },
  {
    title: '口径',
    dataIndex: 'caliber',
  },
  {
    title: '埋深',
    dataIndex: 'buriedDepth',
  },
  {
    title: '地面高程',
    dataIndex: 'elevation',
  },
  {
    title: '所在道路',
    dataIndex: 'road',
  },
  {
    title: '阀门级别',
    dataIndex: 'valveLevel',
  },
  {
    title: '竣工时间',
    dataIndex: 'completion_date',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'GisPipeNetworkList',
  components: {
    importModal,
    RecycleBinModal,
  },

  data () {
    return {
      orderType: 'desc',
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200'],
        showQuickJumper: true,
      },
      // 批量操作相关
      batchOperationLoading: false,
      selectDebounceTimer: null,
      PointList: [],
      LineList: [],
      recycleBinVisible: false,
      createTimeRange: [], // 创建时间范围
      completionTimeRange: [], // 竣工时间范围
      zoneId: '',
      openSelectFile: false,
      importLoading: false,
      fileList: [],
      // 物探点现场图片（siteImages 需要以 JSON 字符串数组提交）
      siteImagesFileList: [],
      siteImagePreviewVisible: false,
      siteImagePreviewUrl: '',
      siteImagePreviewIndex: 0,
      siteImagePreviewUrls: [],
      siteImageScale: 1,
      siteImageRotate: 0,
      canUploadSiteImages: false,
      queryUrl: 'pipe-network/gis/pipe-networks/page',
      addOrUpdateUrl: 'pipe-network/gis/pipe-networks',
      queryOneUrl: 'pipe-network/gis/pipe-networks/work',
      deleteUrl: 'pipe-network/gis/pipe-networks',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-networks/export',
      exportFileName: '物探点数据.xlsx',
      downloadTemplateUrl: 'pipe-network/gis/pipe-networks/template/download',
      downloadTemplateName: '物探点数据导入模板.xlsx',
      roadNameOptions: [], // 道路选择选项
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      featurePointOptions: [], // 特征选项
      appendageOptions: [], // 附属物选项
      structureOptions: [], // 构筑物选项
      road: [], // 分区数据选项
      query: {
        road: [],
        classNo: '',
        geophysicalPointNumber: '',
        featurePoint: undefined,
        appendage: undefined,
        structure: undefined,
        textureMaterial: [],
        caliber: [],
        tenantId: this.$store.state.user.info.tenantId,
        startCreateTime: '',
        endCreateTime: '',
        startCompletionDate: '',
        endCompletionDate: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
      columns,
    }
  },
  filters: {
    statusFilter (key) {
      return STATUS[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
    formatDate (time) {
      const date = new Date(time)
      return formatDate(date, 'YYYY-MM-DD HH:mm:ss')
    },
  },
  created () {
    this.ListRoadNameOptions() // 获取道路列表
    this.listPipeLineMaterialOptions() // 列表管道材料选项
    this.listPipeDiameterSizeOptions()
    this.getFeaturePointOptions()
    this.getAllTenant()
    this.getZoneData()
    this.getPointList()
    this.getLineList()
    
    // 检查路由参数，如果没有classNo参数，则正常初始化
    const { classNo } = this.$route.query
    if (!classNo) {
      // 正常初始化，不是从路由跳转过来的，可以执行重置和查询
      // this.resetList()
    }
    
    // 兼容旧的URL参数格式
    // if (window.location.search.split('=')[1]) {
    //   setTimeout(() => {
    //     this.addOrUpdateHandleEdit(null, window.location.search.split('=')[1])
    //   }, 2000)
    // }
  },
  mounted () {
    // 检查是否从URL传入classNo参数，自动执行搜索
    const { classNo, autoSearch } = this.$route.query
    if (classNo) {
      console.log('从路由接收到分类编码:', classNo)
      // 设置查询条件
      this.query.classNo = classNo
      
      // 延迟执行查询，确保页面已完全加载
      this.$nextTick(() => {
        this.queryList()
        
        // 查询完成后清除URL参数，避免刷新页面时重复自动搜索
        // 只有明确标记了autoSearch才清除参数
        if (autoSearch === 'true') {
          this.$router.replace({ 
            path: this.$route.path,
            query: {} 
          }).catch(() => {})
        }
      })
    }
  },
  methods: {
    // 处理查询参数：空数组不传，有值则保持数组格式（后端期望数组格式）
    processQueryParams (query) {
      const params = { ...query }
      // 处理道路选择 - 保持数组格式
      if (Array.isArray(params.road)) {
        if (params.road.length === 0) {
          delete params.road
        }
        // 多个值保持数组格式，不转换为单个值
      }
      // 处理材质 - 保持数组格式
      if (Array.isArray(params.textureMaterial)) {
        if (params.textureMaterial.length === 0) {
          delete params.textureMaterial
        }
        // 多个值保持数组格式，不转换为单个值
      }
      // 处理口径 - 保持数组格式
      if (Array.isArray(params.caliber)) {
        if (params.caliber.length === 0) {
          delete params.caliber
        }
        // 多个值保持数组格式，不转换为单个值
      }
      return params
    },
    // 兼容后端返回：url 可能在 data.url，也可能直接放在 message 字段里（data 为 null）
    extractSiteImageUrlFromResponse (res) {
      const urlFromData = res && res.data && res.data.url
      if (typeof urlFromData === 'string' && urlFromData) return urlFromData
      const urlFromMessage = res && res.message
      if (typeof urlFromMessage === 'string' && urlFromMessage) return urlFromMessage
      return ''
    },
    getSiteImageUrlsFromFileList (fileList) {
      return (fileList || [])
        .map(f => (f && (f.url || this.extractSiteImageUrlFromResponse(f.response))) || '')
        .filter(Boolean)
    },
    initSiteImagesFromValue (siteImages) {
      let urls = []

      if (Array.isArray(siteImages)) {
        urls = siteImages
      } else if (typeof siteImages === 'string' && siteImages) {
        try {
          const parsed = JSON.parse(siteImages)
          if (Array.isArray(parsed)) urls = parsed
        } catch (e) {
          // 兼容非 JSON 格式（如逗号分隔）
          urls = siteImages.split(',').map(s => s.trim()).filter(Boolean)
        }
      }

      this.siteImagesFileList = (urls || []).filter(Boolean).map((url, index) => {
        const name = (typeof url === 'string' && url.split('/').pop()) || `image_${index + 1}.jpg`
        return {
          uid: `site-${index}`,
          name,
          status: 'done',
          url,
        }
      })

      // 同步预览列表
      this.siteImagePreviewUrls = urls || []

      // 同步到表单字段，确保提交时带上
      this.$nextTick(() => {
        if (this.addOrUpdateForm) {
          this.addOrUpdateForm.setFieldsValue({
            siteImages: urls && urls.length ? JSON.stringify(urls) : '',
          })
        }
      })
    },
    beforeSiteImageUpload (file) {
      if (!this.canUploadSiteImages) {
        this.$message.warning('新增时不支持上传图片，请先保存后再编辑上传')
        return false
      }
      if (this.siteImagesFileList && this.siteImagesFileList.length >= 3) {
        this.$message.warning('最多只能上传3张图片')
        return false
      }
      const isImage = file && file.type && file.type.startsWith('image/')
      if (!isImage) {
        this.$message.warning('只能上传图片文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.warning('图片大小不能超过10MB')
        return false
      }
      return true
    },
    handleSiteImageUpload (options) {
      const { file, onSuccess, onError } = options
      const formData = new FormData()
      formData.append('file', file)

      this.$http
        .post('/pipe-network/gis/pipe-networks/upload-site-image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          const url = this.extractSiteImageUrlFromResponse(res)
          if (res && res.code === 0 && url) {
            onSuccess(res, file)
          } else {
            onError(new Error((res && res.message) || '图片上传失败'))
          }
        })
        .catch((err) => {
          onError(err)
        })
    },
    handleSiteImageChange (info) {
      const nextList = (info.fileList || []).map((f) => {
        // 上传成功后，把后端返回的 url 写回到 file.url，方便预览/提交
        if (f && f.response) {
          const url = this.extractSiteImageUrlFromResponse(f.response)
          if (url) f.url = url
        }
        return f
      })

      // 限制最多 3 张
      this.siteImagesFileList = nextList.slice(0, 3)
      const urls = this.getSiteImageUrlsFromFileList(this.siteImagesFileList)
      this.siteImagePreviewUrls = urls

      if (this.addOrUpdateForm) {
        this.addOrUpdateForm.setFieldsValue({
          siteImages: urls.length ? JSON.stringify(urls) : '',
        })
      }
    },
    handleSiteImagePreview (file) {
      const urls = this.getSiteImageUrlsFromFileList(this.siteImagesFileList)
      this.siteImagePreviewUrls = urls
      const currentUrl = (file && (file.url || this.extractSiteImageUrlFromResponse(file.response) || file.thumbUrl)) || ''
      const index = urls.findIndex(u => u === currentUrl)
      this.siteImagePreviewIndex = index >= 0 ? index : 0
      this.siteImagePreviewUrl = urls[this.siteImagePreviewIndex] || currentUrl
      this.siteImagePreviewVisible = true
      this.handleImageReset()
      // 添加键盘监听
      window.addEventListener('keydown', this.handlePreviewKeyDown)
    },
    handleSiteImagePreviewCancel () {
      this.siteImagePreviewVisible = false
      this.siteImagePreviewUrl = ''
      this.siteImagePreviewIndex = 0
      this.siteImagePreviewUrls = []
      // 移除键盘监听
      window.removeEventListener('keydown', this.handlePreviewKeyDown)
    },
    handlePreviewKeyDown (e) {
      if (!this.siteImagePreviewVisible) return
      if (e.key === 'ArrowLeft' && this.siteImagePreviewIndex > 0) {
        this.previewPrev()
      } else if (e.key === 'ArrowRight' && this.siteImagePreviewIndex < this.siteImagePreviewUrls.length - 1) {
        this.previewNext()
      } else if (e.key === 'Escape') {
        this.handleSiteImagePreviewCancel()
      }
    },
    handleImageScale (step) {
      const newScale = this.siteImageScale + step
      if (newScale > 0.2 && newScale < 5) {
        this.siteImageScale = newScale
      }
    },
    handleImageRotate () {
      this.siteImageRotate += 90
    },
    handleImageReset () {
      this.siteImageScale = 1
      this.siteImageRotate = 0
    },
    handleBodyWheel (e) {
      const step = e.deltaY > 0 ? -0.1 : 0.1
      this.handleImageScale(step)
    },
    previewPrev () {
      if (this.siteImagePreviewIndex > 0) {
        this.siteImagePreviewIndex -= 1
        this.siteImagePreviewUrl = this.siteImagePreviewUrls[this.siteImagePreviewIndex] || ''
        this.handleImageReset()
      }
    },
    previewNext () {
      if (this.siteImagePreviewIndex < this.siteImagePreviewUrls.length - 1) {
        this.siteImagePreviewIndex += 1
        this.siteImagePreviewUrl = this.siteImagePreviewUrls[this.siteImagePreviewIndex] || ''
        this.handleImageReset()
      }
    },

    // 覆盖 mixin：打开编辑时初始化图片列表
    addOrUpdateHandleEdit (id, no) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.isUpdate = true
      this.canUploadSiteImages = true
      // 先清空图片
      this.initSiteImagesFromValue('')

      this.$http
        .get(`${this.queryOneUrl}/${this.currentId}`)
        .then(({ data }) => {
          this.currentId = data.id
          this.addOrUpdateForm.setFieldsValue(data)
          this.initSiteImagesFromValue(data && data.siteImages)
        })
        .catch(() => { })
    },
    // 覆盖 mixin：打开新增时清空图片
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.isEditMode = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      // 新增不允许上传图片
      this.canUploadSiteImages = false
      this.initSiteImagesFromValue('')

      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue(data)
            this.initSiteImagesFromValue(data && data.siteImages)
          })
          .catch(() => { })
      }
    },
    // 覆盖 mixin：关闭时清空图片/预览状态
    handleCancel () {
      this.addOrUpdateForm.resetFields()
      this.initSiteImagesFromValue('')
      this.handleSiteImagePreviewCancel()
      this.canUploadSiteImages = false
    },

    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {
          tenantId: this.$store.state.user.info.tenantId,
          road: [],
          textureMaterial: [],
          caliber: []
        }
      }
      this.createTimeRange = []
      this.completionTimeRange = []
      this.pagination.current = 1
      this.selectedRows = []
      
      // 清除URL中的查询参数
      if (this.$route.query.classNo || this.$route.query.autoSearch) {
        this.$router.replace({ 
          path: this.$route.path,
          query: {} 
        }).catch(() => {})
      }
      
      this.queryList()
    },
    // 序列化查询参数，确保数组正确序列化
    serializeParams (params) {
      const searchParams = new URLSearchParams()
      Object.keys(params).forEach(key => {
        const value = params[key]
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            // 数组格式：多个同名参数 param=value1&param=value2
            value.forEach(item => {
              searchParams.append(key, item)
            })
          } else {
            searchParams.append(key, value)
          }
        }
      })
      return searchParams.toString()
    },
    // 覆盖 mixin 的 queryList 方法，处理多选参数
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.processQueryParams(this.query)
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
          paramsSerializer: (params) => {
            return this.serializeParams(params)
          }
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 覆盖 mixin 的 pageQueryList 方法，处理多选参数
    pageQueryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.processQueryParams(this.query)
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
          paramsSerializer: (params) => {
            return this.serializeParams(params)
          }
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    onDateChange (date, dateString) {
      if (date && date.length === 2) {
        this.query.startCreateTime = dateString[0]
        this.query.endCreateTime = dateString[1]
      } else {
        this.query.startCreateTime = ''
        this.query.endCreateTime = ''
      }
    },
    onCompletionDateChange (date, dateString) {
      if (date && date.length === 2) {
        this.query.startCompletionDate = dateString[0]
        this.query.endCompletionDate = dateString[1]
      } else {
        this.query.startCompletionDate = ''
        this.query.endCompletionDate = ''
      }
    },
    moment,
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-networks/empty/pipe/network').then((res) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        },
      })
    },
    getLineList () {
      const params = {
        dictCode: 'PIPING_MATERIAL',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.LineList = data
      })
    },
    getPointList () {
      const params = {
        dictCode: 'FEATURE_POINTS',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.PointList = data
      })
    },
    modalFormOk () {
      console.log('recycleBinVisible', recycleBinVisible)
      this.queryList()
    },
    // 关闭选择分区页面时
    close (val) {
      console.log(val)
      this.zoneId = val
      this.openSelectFile = true
    },
    importHandle () {
      this.$refs.importModal.show()
    },
    changeFile (info) { },
    customRequest (data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('zone_id', this.zoneId)
      this.saveFile(formData)
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis/pipe-networks/import',
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: '管点导入失败数据.xlsx' }))
        .then(({ hasErrorFile, message }) => {
          this.queryList()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    ListRoadNameOptions () {
      listPipeNetworkByGroupProperties('road').then(({ data }) => {
        this.roadNameOptions = data
      })
    },
    listPipeLineMaterialOptions () {
      listPipeNetworkByGroupProperties('texture_material').then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeDiameterSizeOptions () {
      listPipeNetworkByGroupProperties('caliber').then(({ data }) => {
        this.pipeDiameterSizeOptions = data
      })
    },
    getFeaturePointOptions () {
      listPipeNetworkByGroupProperties('feature_point').then(({ data }) => {
        this.featurePointOptions = data
      })

      listPipeNetworkByGroupProperties('appendage').then(({ data }) => {
        this.appendageOptions = data
      })

      listPipeNetworkByGroupProperties('structure').then(({ data }) => {
        this.structureOptions = data
      })
    },
    // 优化的选择变化处理，添加防抖
    onSelectChange (selectedRowKeys) {
      // 清除之前的定时器
      if (this.selectDebounceTimer) {
        clearTimeout(this.selectDebounceTimer)
      }

      // 设置防抖延迟
      this.selectDebounceTimer = setTimeout(() => {
        this.selectedRows = selectedRowKeys
        console.log('选中行数:', selectedRowKeys.length)
      }, 100) // 100ms防抖延迟
    },
    // 优化的批量删除方法
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }

      // 限制批量删除数量
      if (this.selectedRows.length > 100) {
        return this.$message.warn('批量删除数量不能超过100条，请分批删除')
      }

      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.batchOperationLoading = true
          _this.$http
            .delete(_this.deleteUrl, {
              data: _this.selectedRows,
            })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.resetList()
                _this.queryList()
              }
            })
            .catch(() => { })
            .finally(() => {
              _this.batchOperationLoading = false
            })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    // 在地图上查看管点详情
    viewOnMap (record) {
      console.log('viewOnMap 被调用，record:', record);
      
      // 解析 GeoJSON 数据
      let geoJsonData = null
      try {
        if (record.geoJson) {
          console.log('原始 geoJson:', record.geoJson);
          geoJsonData = typeof record.geoJson === 'string' ? JSON.parse(record.geoJson) : record.geoJson
          console.log('解析后的 geoJsonData:', geoJsonData);
          
          if (!geoJsonData || !geoJsonData.coordinates || geoJsonData.type !== 'Point') {
            console.error('GeoJSON 验证失败:', { 
              hasData: !!geoJsonData, 
              hasCoordinates: !!(geoJsonData && geoJsonData.coordinates),
              type: geoJsonData ? geoJsonData.type : 'undefined'
            });
            this.$message.warning('该数据没有有效的坐标信息')
            return
          }
        } else {
          console.error('record.geoJson 为空');
          this.$message.warning('该数据没有坐标信息')
          return
        }
      } catch (error) {
        console.error('解析 GeoJSON 失败:', error, record.geoJson)
        this.$message.error('坐标数据格式错误')
        return
      }

      const queryParams = {
        type: 'point', // 标识为管点
        classNo: record.class_no, // 分类编号
        geoJson: JSON.stringify(geoJsonData), // 完整的 GeoJSON 数据
        name: record.geophysicalPointNumber || '管点' // 物探点号
      };
      
      console.log('准备跳转到地图，query 参数:', queryParams);

      // 跳转到地图页面，携带完整的 GeoJSON 数据
      this.$router.push({
        path: '/new-one-map',
        query: queryParams
      })
    },
  },
  watch: {},
  beforeDestroy () {
    // 清理防抖定时器
    if (this.selectDebounceTimer) {
      clearTimeout(this.selectDebounceTimer)
    }
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/* 图片预览全屏样式 */
/deep/ .full-screen-preview-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    background: transparent;
    box-shadow: none;
  }
}

.preview-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  color: #fff;
  z-index: 10;
  background: rgba(0, 0, 0, 0.2);

  .preview-count {
    font-size: 16px;
    font-weight: 500;
  }

  .preview-close {
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: scale(1.2);
      color: #ff4d4f;
    }
  }
}

.preview-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  .nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s;
    z-index: 20;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-50%) scale(1.1);
    }

    &.left {
      left: 30px;
    }
    &.right {
      right: 30px;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none; /* 防止图片干扰鼠标滚轮 */
  }

  .preview-image {
    max-width: 90%;
    max-height: 85vh;
    transition: transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    user-select: none;
    pointer-events: auto;
  }
}

.preview-footer {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;

  .anticon {
    font-size: 28px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: #fff;
      transform: translateY(-2px);
    }
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
